import { render, staticRenderFns } from "./QuestionBankTopicEdit.vue?vue&type=template&id=5947f00c&scoped=true&"
import script from "./QuestionBankTopicEdit.vue?vue&type=script&lang=js&"
export * from "./QuestionBankTopicEdit.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBankTopicEdit.vue?vue&type=style&index=0&id=5947f00c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5947f00c",
  null
  
)

export default component.exports